// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match register-textbox dimensions */
.category-selector_container__r0xrU {
  width: 100%;
  max-width: 463px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.category-selector_label-wrapper__V\\+T3N {
  width: 100%;
  max-width: 463px;
  min-width: 200px;
  display: inline-block;
  border: none;
  background: none;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 6px;
  margin-left: 20px;
  margin-top: 0;
  font-family: "FreckleFace", serif;
  font-weight: 400;
  font-style: normal;
  color: #FEE5B1;
  font-size: clamp(16px, 1.4vw, 22px);
}

.category-selector_searchBox__21jr2 {
  width: 100%;
  padding: clamp(14px, 1.8vh, 20px) clamp(18px, 1.8vw, 28px);
  border: none;
  border-radius: 50px;
  background: linear-gradient(270deg, #CFE5FF 0%, #FFE5B0 100%);
  color: black;
  font-size: clamp(15px, 1.3vw, 20px);
  box-sizing: border-box;
}

.category-selector_searchBox__21jr2:focus {
  outline: none;
  box-shadow: 0 0 4px 1px #FFE5B0;
}

.category-selector_searchBox__21jr2::placeholder {
  color: #9a9a9a;
  opacity: 1;
}

.category-selector_selectedContainer__5gg\\+D {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  min-height: 40px;
}

.category-selector_selectedChip__tRRfd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(180deg, #CFE5FF 0%, #FFE5B0 100%);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s ease;
}

.category-selector_selectedChip__tRRfd:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(207, 229, 255, 0.3);
}

.category-selector_removeIcon__PUKMF {
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  color: rgba(26, 26, 26, 0.6);
}

.category-selector_categoryList__hKzVM {
  max-height: 400px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 10px;
  padding: 5px;
}

.category-selector_categoryList__hKzVM::-webkit-scrollbar {
  width: 8px;
}

.category-selector_categoryList__hKzVM::-webkit-scrollbar-track {
  background: rgba(255, 229, 176, 0.1);
  border-radius: 10px;
}

.category-selector_categoryList__hKzVM::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #CFE5FF 0%, #FFE5B0 100%);
  border-radius: 10px;
}

.category-selector_categoryList__hKzVM::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #b8d4ff 0%, #ffe099 100%);
}

.category-selector_categoryItem__OuzWB {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  border-radius: 30px;
  background: linear-gradient(180deg, #CFE5FF 0%, #FFE5B0 100%);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 3px solid transparent;
  aspect-ratio: 1;
  min-height: 90px;
  position: relative;
}

.category-selector_categoryItem__OuzWB:hover {
  transform: scale(1.08);
  box-shadow: 0 4px 12px rgba(207, 229, 255, 0.4);
}

.category-selector_categoryItem__OuzWB.category-selector_selected__Oajk6 {
  border-color: #1a1a1a;
  box-shadow: 0 0 0 2px rgba(26, 26, 26, 0.2);
}

.category-selector_categoryName__EY8CI {
  color: #000000;
  font-size: clamp(11px, 1vw, 14px);
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
  hyphens: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.category-selector_noResults__uSgR0 {
  text-align: center;
  color: rgba(254, 229, 177, 0.6);
  padding: 20px;
  font-size: clamp(14px, 1.2vw, 16px);
}

/* Tablet adjustments */
@media (max-width: 1024px) {
  .category-selector_container__r0xrU,
  .category-selector_label-wrapper__V\\+T3N {
    width: 100%;
    max-width: 500px;
  }

  .category-selector_searchBox__21jr2 {
    padding: 14px 18px;
    font-size: 16px;
  }

  label {
    font-size: 16px;
    margin-left: 16px;
  }

  .category-selector_categoryList__hKzVM {
    max-height: 350px;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }

  .category-selector_categoryItem__OuzWB {
    min-height: 80px;
    padding: 10px 6px;
  }

  .category-selector_categoryName__EY8CI {
    font-size: 12px;
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .category-selector_container__r0xrU,
  .category-selector_label-wrapper__V\\+T3N {
    width: 100%;
    max-width: 100%;
  }

  .category-selector_searchBox__21jr2 {
    padding: 14px 18px;
    font-size: 15px;
  }

  label {
    font-size: 15px;
    margin-left: 14px;
  }

  .category-selector_categoryList__hKzVM {
    max-height: 250px;
    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
    gap: 8px;
  }

  .category-selector_categoryItem__OuzWB {
    min-height: 70px;
    padding: 8px 4px;
  }

  .category-selector_categoryName__EY8CI {
    font-size: 10px;
  }

  .category-selector_selectedChip__tRRfd {
    font-size: 11px;
    padding: 4px 8px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/UI/common/Inputs/category-selector.module.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,0DAA0D;EAC1D,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,2DAA2D;EAC7D;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Match register-textbox dimensions */\n.container {\n  width: 100%;\n  max-width: 463px;\n  min-width: 200px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.label-wrapper {\n  width: 100%;\n  max-width: 463px;\n  min-width: 200px;\n  display: inline-block;\n  border: none;\n  background: none;\n  text-align: left;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 6px;\n  margin-left: 20px;\n  margin-top: 0;\n  font-family: \"FreckleFace\", serif;\n  font-weight: 400;\n  font-style: normal;\n  color: #FEE5B1;\n  font-size: clamp(16px, 1.4vw, 22px);\n}\n\n.searchBox {\n  width: 100%;\n  padding: clamp(14px, 1.8vh, 20px) clamp(18px, 1.8vw, 28px);\n  border: none;\n  border-radius: 50px;\n  background: linear-gradient(270deg, #CFE5FF 0%, #FFE5B0 100%);\n  color: black;\n  font-size: clamp(15px, 1.3vw, 20px);\n  box-sizing: border-box;\n}\n\n.searchBox:focus {\n  outline: none;\n  box-shadow: 0 0 4px 1px #FFE5B0;\n}\n\n.searchBox::placeholder {\n  color: #9a9a9a;\n  opacity: 1;\n}\n\n.selectedContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  min-height: 40px;\n}\n\n.selectedChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: linear-gradient(180deg, #CFE5FF 0%, #FFE5B0 100%);\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1a1a1a;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.selectedChip:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(207, 229, 255, 0.3);\n}\n\n.removeIcon {\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 1;\n  color: rgba(26, 26, 26, 0.6);\n}\n\n.categoryList {\n  max-height: 400px;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n  gap: 10px;\n  padding: 5px;\n}\n\n.categoryList::-webkit-scrollbar {\n  width: 8px;\n}\n\n.categoryList::-webkit-scrollbar-track {\n  background: rgba(255, 229, 176, 0.1);\n  border-radius: 10px;\n}\n\n.categoryList::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #CFE5FF 0%, #FFE5B0 100%);\n  border-radius: 10px;\n}\n\n.categoryList::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #b8d4ff 0%, #ffe099 100%);\n}\n\n.categoryItem {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 8px;\n  border-radius: 30px;\n  background: linear-gradient(180deg, #CFE5FF 0%, #FFE5B0 100%);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 3px solid transparent;\n  aspect-ratio: 1;\n  min-height: 90px;\n  position: relative;\n}\n\n.categoryItem:hover {\n  transform: scale(1.08);\n  box-shadow: 0 4px 12px rgba(207, 229, 255, 0.4);\n}\n\n.categoryItem.selected {\n  border-color: #1a1a1a;\n  box-shadow: 0 0 0 2px rgba(26, 26, 26, 0.2);\n}\n\n.categoryName {\n  color: #000000;\n  font-size: clamp(11px, 1vw, 14px);\n  font-weight: 600;\n  line-height: 1.3;\n  text-align: center;\n  width: 100%;\n  word-wrap: break-word;\n  hyphens: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n}\n\n.noResults {\n  text-align: center;\n  color: rgba(254, 229, 177, 0.6);\n  padding: 20px;\n  font-size: clamp(14px, 1.2vw, 16px);\n}\n\n/* Tablet adjustments */\n@media (max-width: 1024px) {\n  .container,\n  .label-wrapper {\n    width: 100%;\n    max-width: 500px;\n  }\n\n  .searchBox {\n    padding: 14px 18px;\n    font-size: 16px;\n  }\n\n  label {\n    font-size: 16px;\n    margin-left: 16px;\n  }\n\n  .categoryList {\n    max-height: 350px;\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  }\n\n  .categoryItem {\n    min-height: 80px;\n    padding: 10px 6px;\n  }\n\n  .categoryName {\n    font-size: 12px;\n  }\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n  .container,\n  .label-wrapper {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .searchBox {\n    padding: 14px 18px;\n    font-size: 15px;\n  }\n\n  label {\n    font-size: 15px;\n    margin-left: 14px;\n  }\n\n  .categoryList {\n    max-height: 250px;\n    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));\n    gap: 8px;\n  }\n\n  .categoryItem {\n    min-height: 70px;\n    padding: 8px 4px;\n  }\n\n  .categoryName {\n    font-size: 10px;\n  }\n\n  .selectedChip {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `category-selector_container__r0xrU`,
	"label-wrapper": `category-selector_label-wrapper__V+T3N`,
	"searchBox": `category-selector_searchBox__21jr2`,
	"selectedContainer": `category-selector_selectedContainer__5gg+D`,
	"selectedChip": `category-selector_selectedChip__tRRfd`,
	"removeIcon": `category-selector_removeIcon__PUKMF`,
	"categoryList": `category-selector_categoryList__hKzVM`,
	"categoryItem": `category-selector_categoryItem__OuzWB`,
	"selected": `category-selector_selected__Oajk6`,
	"categoryName": `category-selector_categoryName__EY8CI`,
	"noResults": `category-selector_noResults__uSgR0`
};
export default ___CSS_LOADER_EXPORT___;
